import React from 'react';

import { PROCESSOR_OPT_STATUS } from '../../constants/processors';

import FailMessage from './FailMessage';
import SuccessMessage from './SuccessMessage';


function CheckoutMessage(props) {
  const {
    anchor,
    opStatus,
    anchorFirstName,
    checkoutImage,
    isRenewal,
    loading,
    productType1,
    user,
    errorCode,
    errorMessage,
    purchaseId,
    transactionId,
    searchParams,
    processorId,
  } = props;

  if (opStatus === PROCESSOR_OPT_STATUS.SUCCESS) {
    return (
      <SuccessMessage
        anchorFirstName={anchorFirstName}
        checkoutImage={checkoutImage}
        loading={loading}
        productType={productType1}
        renewal={isRenewal}
        user={user}
      />
    );
  }

  return (
    <FailMessage
      anchor={anchor}
      errorCode={errorCode}
      errorMessage={errorMessage}
      processorId={processorId}
      productType1={productType1}
      purchaseId={purchaseId}
      searchParams={searchParams}
      transactionId={transactionId}
      user={user}
    />
  );
}

export default CheckoutMessage;
